
export const drawingElements: DrawingElement[] = [
    {
        iconName: 'x',
        value: 'cross',
        label: 'Croix',
        subElements: [],
    },
    {
        iconName: 'circle',
        value: 'circle',
        label: 'Cercle',
        subElements: [],
    },
    {
        iconName: 'square',
        value: 'square',
        label: 'Carré',
        subElements: [],
    },
    {
        iconName: 'triangle',
        value: 'triangle',
        label: 'Triangle',
        subElements: [],
    },
    {
        iconName: 'line',
        value: 'line',
        label: 'Ligne',
        subElements: [
            {
                label: 'Libre',
                value: 'CUSTOM',
                iconName: 'slash'
            },
            {
                label: 'Horizontal',
                value: 'HORIZONTAL',
                iconName: 'minus'
            },
            {
                label: 'Vertical',
                value: 'VERTICAL',
                iconName: 'minus-vertical'
            }
        ],
    },
    {
        iconName: 'arrow-right',
        value: 'arrow',
        label: 'Flèche',
        subElements: [],
    },
    {
        iconName: 'angle',
        value: 'angle',
        label: 'Angle',
        subElements: [
            {
                label: 'Libre',
                value: 'CUSTOM',
                iconName: 'slash'
            },
            {
                label: 'Horizontal',
                value: 'HORIZONTAL',
                iconName: 'minus'
            },
            {
                label: 'Vertical',
                value: 'VERTICAL',
                iconName: 'minus-vertical'
            }
        ],
    },
    {
        iconName: 'columns-2',
        value: 'columns',
        label: 'Colonnes',
        subElements: [],
    },
    {
        iconName: 'layout-rows',
        value: 'rows',
        label: 'Rangés',
        subElements: [],
    },
    {
        iconName: 'vector-bezier-arc',
        value: 'shape',
        label: 'Forme libre',
        subElements: [],
    }
];

export class DrawingDataItemCommon {
    thickness: number;
    color: string;
    size: number;
    label: string;
    name: string;
}

export abstract class DrawingDataItem {
    state: 'IN_PROGRESS' | 'DONE';
    typeValue: string;
    _subTypeValue: string;
    common: DrawingDataItemCommon;
    properties: any;

    public abstract getPointsToMove(): DrawingDataItemPoint[];

    moveX(xDelta: number, pointIndex = -1) {
        const points = this.getPointsToMove();
        console.log(points, pointIndex);
        if (pointIndex > -1 && pointIndex < points?.length) {
            if (points[pointIndex].point) {
                points[pointIndex].point.x += xDelta;
            }
        } else {
            points.filter(value => value?.point)
                .filter(value => value.point.x || value.point.x === 0)
                .forEach(value => value.point.x += xDelta);
        }
    }

    moveY(yDelta: number, pointIndex = -1) {
        const points = this.getPointsToMove();
        if (pointIndex > -1 && pointIndex < points?.length) {
            if (points[pointIndex].point) {
                points[pointIndex].point.y += yDelta;
            }
        } else {
            this.getPointsToMove().filter(value => value?.point)
                .filter(value => value.point.y || value.point.y === 0)
                .forEach(value => value.point.y += yDelta);
        }
    }

    get subTypeValue(): string {
        return this._subTypeValue;
    }

    set subTypeValue(value: string) {
        this._subTypeValue = value;
        this.subTypeValueChanged();
    }

    protected subTypeValueChanged(): void {

    }

    public onMouseUp(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        return undefined;
    }

    public onMouseDown(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        return undefined;
    }

    public onMouseMove(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        return undefined;
    }

    public onMouseDbClick(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        return undefined;
    }

    public draw(ctx: CanvasRenderingContext2D) {
    }

    public stopDrawing(): void {

    }

    protected applyCommonToCanvas(ctx: CanvasRenderingContext2D) {
        ctx.lineWidth = this.common.thickness;
        ctx.strokeStyle = this.common.color;
    }
}

export class DrawingDataItemPoint {
    point: any;
    visibleForUser = true;

    public static fromVisiblePoint(point: any): DrawingDataItemPoint {
        return DrawingDataItemPoint.fromPoint(point, true);
    }

    public static fromNotVisiblePoint(point: any): DrawingDataItemPoint {
        return DrawingDataItemPoint.fromPoint(point, false);
    }

    public static fromPoint(point: any, visibleForUser: boolean): DrawingDataItemPoint {
        return {
            point,
            visibleForUser
        }
    }
}

export class DrawingElementSubElement {
    value: string;
    label: string;
    iconName: string;
}

export class DrawingElement {
    value: string;
    label: string;
    iconName: string;
    subElements: DrawingElementSubElement[];
}



export class DrawingData{
    items: DrawingDataItem[];
}


export class DrawingDataItemDrawResult {
    changed: boolean;
    stillDrawing: boolean;

    public static empty(): DrawingDataItemDrawResult {
        return {
            changed: false,
            stillDrawing: false
        }
    }
}